import React from "react";
import {CCard, CCardBody} from "@coreui/react";
import {useTranslation} from "react-i18next";
import {withErrorBoundary} from "@sentry/react";


const FallbackStub = () => {
  const {t} = useTranslation();

  return (
    <CCard>
      <CCardBody>
        <div className="text-center">{t("notification:message.error.boundary", "Unfortunately, an error has occurred in this component.")}</div>
      </CCardBody>
    </CCard>
  );
};

export default withErrorBoundary(FallbackStub, {fallback: () => "Unfortunately, an error has occurred in this component."});